<!-- delivery partner map -->

<div class="ad-model-container mb-0">
  <div class="ad-model-header d-flex flex-column gap-2">
    <div class="w-100 d-flex flex-row justify-content-between align-items-center ad-model-header-inner">
      <div class="mb-0 d-flex align-items-start justify-content-start flex-column gap-1">
        <h4 class="fw-bold">3PL Map</h4>
        <span class="vendor-name text-first-letter line-clamp-1 d-flex align-items-center gap-1">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
            <path
              d="M2 5L9 2L15 5L21.303 2.2987C21.5569 2.18992 21.8508 2.30749 21.9596 2.56131C21.9862 2.62355 22 2.69056 22 2.75827V19L15 22L9 19L2.69696 21.7013C2.44314 21.8101 2.14921 21.6925 2.04043 21.4387C2.01375 21.3765 2 21.3094 2 21.2417V5ZM16 19.3955L20 17.6812V5.03308L16 6.74736V19.3955ZM14 19.2639V6.73607L10 4.73607V17.2639L14 19.2639ZM8 17.2526V4.60451L4 6.31879V18.9669L8 17.2526Z">
            </path>
          </svg>
          <small class="text-first-letter">
            ({{userData.fullName}})
          </small>
        </span>
      </div>

      <div class="d-flex justify-content-end align-items-end gap-2 ad-me-8">
        @if(dp_setup == 'Own Cluster'){
        <div class="action-buttons-container">
          <button type="button" placement="top" class="btn ad-btn-small active" (click)="customerCluster()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32">
              <path fill="currentColor"
                d="M30 6a3.992 3.992 0 0 0-7.977-.224L9.586 8.263A3.99 3.99 0 1 0 5 13.858v8.284A3.992 3.992 0 1 0 9.858 27h8.284a3.991 3.991 0 1 0 5.595-4.586l2.487-12.437A3.995 3.995 0 0 0 30 6m-4-2a2 2 0 1 1-2 2a2 2 0 0 1 2-2M4 10a2 2 0 1 1 2 2a2 2 0 0 1-2-2m2 18a2 2 0 1 1 2-2a2 2 0 0 1-2 2m12.142-3H9.858A4 4 0 0 0 7 22.142v-8.284a3.99 3.99 0 0 0 2.977-3.634l12.437-2.487a4 4 0 0 0 1.849 1.85l-2.487 12.436A3.99 3.99 0 0 0 18.142 25M22 28a2 2 0 1 1 2-2a2 2 0 0 1-2 2">
              </path>
            </svg>
            <span>Own cluster</span>
          </button>
        </div>
        }
        @if(userData.role_id == constant.RoleId.masterAgency || userData.role_id == constant.RoleId.agency) {

        <div class="ad-form-group ad-assign-method mb-0">
          <label class="ad-control-label">Change All Branch 3pl Setup</label>
          <ng-select class="ad-select" bindLabel="name" bindValue="value" placeholder="Select"
            (change)="onApplyDpSetupChange($event)" [(ngModel)]="apply_dp_setup" [searchable]="true" [clearable]="false"
            [items]="applydpList">
          </ng-select>
        </div>
        }
        @if(userData.role_id == constant.RoleId.vendor) {
        <div class="ad-form-group ad-assign-method mb-0">
          <label class="ad-control-label">Dp setup</label>
          <ng-select class="ad-select ad-text-select" bindLabel="name" bindValue="value" placeholder="Select"
            (change)="dpSetupMethod()" [(ngModel)]="dp_setup" [searchable]="true" [clearable]="false" [items]="dpList">
          </ng-select>
        </div>
        }

        <!-- @if( deliveryPartnerIds.includes(constant.deliveryPartnerViaOndc)&& ondcActiveCheck) {
          <div class="ad-form-group ad-assign-method mb-0 cus-max-w-170">
            <label class="ad-control-label">ONDC 3pl Mapping</label>
            <ng-select class="ad-select" bindLabel="name" bindValue="url" placeholder="Select"
                [(ngModel)]="ondcConfigListData" [searchable]="true" [closeOnSelect]="false" [clearable]="true"multiple="true" [items]="ondcConfigList">
            </ng-select>
          </div>
        } -->
        <div class="ad-form-group ad-assign-method mb-0">
          <label class="ad-control-label">3PL Assign Method</label>
          <ng-select class="ad-select" bindLabel="name" bindValue="name" placeholder="Select"
            (change)="thirdPartyMethod()" [(ngModel)]="dp_push_mechanisum" [searchable]="true" [clearable]="false"
            [items]="constant.dpAssignMethod">
          </ng-select>
        </div>

        <!-- <div class="rtb-checkbox">
          <div class="checkbox checkbox-primary">
            <input id="checkbox-primary-1" type="checkbox" [checked]="dp_rearrange_with_eta"
              (change)="checkValue($event)">
            <label for="checkbox-primary-1">Reassign with ETA</label>
          </div>
        </div> -->
      </div>
    </div>
    <div class="ad-close" data-dismiss="modal" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m7 7l10 10M7 17L17 7"
          stroke-width="1" />
      </svg>
    </div>
  </div>
  @if (deliveryPartnerShow) {
  <div class="ad-delivery-partner-container" [class.blurred-container]="dp_setup !== 'Own'">
    <div class="ad-delivery-partner-container-inner" dragula="DPM" [(dragulaModel)]="UserDeliveryPartnerMap"
      (dragulaModelChange)="interChangeList($event)">
      @for (dp of UserDeliveryPartnerMap; track dp; let i = $index) {
      <div class="ad-delivery-main-card" style="padding: 10px 50px 10px 10px; position: relative;">
        <div class="d-flex justify-content-start align-items-center gap-2">
          <div class="ad-partner-header d-flex flex-row justify-content-start align-items-center">
            <div class="ad-partner-logo">
              <img [src]="dp?.DeliveryPartner?.icon_url"
                style="width: 40px; height: 40px; border-radius: 50%; object-fit: cover;"
                (error)="dp.DeliveryPartner.icon_url = 'assets/images/error-img-3pl.png';" alt="partner logo">
            </div>
            <h6 class="mb-0 text-ellips-1 ">{{dp?.DeliveryPartner?.full_name}}</h6>
          </div>
        </div>

        <div class="d-flex justify-content-end align-items-center gap-2">
          <div class="adl-dynamic-setup">
            @if(dp.delivery_partner_user_id == constant.deliveryPartnerViaOndc && dp.status === 'Active'){
            <button class="btn ad-btn-small active ondcBtn" (click)="openOndcPopup(dp, i)">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                ngbTooltip="Edit Setup">
                <path fill="currentColor" fill-rule="evenodd"
                  d="M1.25 12C1.25 6.063 6.063 1.25 12 1.25a.75.75 0 0 1 0 1.5A9.25 9.25 0 1 0 21.25 12a.75.75 0 0 1 1.5 0c0 5.937-4.813 10.75-10.75 10.75S1.25 17.937 1.25 12m15.52-9.724a3.503 3.503 0 0 1 4.954 4.953l-6.648 6.649c-.371.37-.604.604-.863.806a5.3 5.3 0 0 1-.987.61c-.297.141-.61.245-1.107.411l-2.905.968a1.492 1.492 0 0 1-1.887-1.887l.968-2.905c.166-.498.27-.81.411-1.107q.252-.526.61-.987c.202-.26.435-.492.806-.863zm3.893 1.06a2.003 2.003 0 0 0-2.832 0l-.376.377q.032.145.098.338c.143.413.415.957.927 1.469a3.9 3.9 0 0 0 1.807 1.025l.376-.376a2.003 2.003 0 0 0 0-2.832m-1.558 4.391a5.4 5.4 0 0 1-1.686-1.146a5.4 5.4 0 0 1-1.146-1.686L11.218 9.95c-.417.417-.58.582-.72.76a4 4 0 0 0-.437.71c-.098.203-.172.423-.359.982l-.431 1.295l1.032 1.033l1.295-.432c.56-.187.779-.261.983-.358q.378-.18.71-.439c.177-.139.342-.302.759-.718z"
                  clip-rule="evenodd" />
              </svg></button>
            }
            <!-- The ONDC row drops the hidden waiting-time slot in Parallel mode so its Edit Setup button sits flush with Push Wait Time. -->
            @if(dp.delivery_partner_user_id != constant.deliveryPartnerViaOndc || dp_push_mechanisum != 'Parallel'){
            <div class="ad-partner-wrapper d-flex justify-content-end align-items-center"
              [class.invisible]="!(dp_push_mechanisum == 'Parallel' && dp.delivery_partner_user_id == 1 || dp_push_mechanisum != 'Parallel')">
              <div class="ad-timer-container d-flex flex-row justify-content-center align-items-start gap-2">
                <small class="mr-2">Waiting time (mins)</small>
                <div class="position-relative">
                  <input type="number" inputmode="decimal" class="ad-form-control"
                    (keyup)="editFunction($event,i,'waiting_time_in_min');" (blur)="validateWaitingTime($event,i)"
                    min="1" max="60" [ngModel]="dp.waiting_time_in_min"
                    (ngModelChange)="dp.waiting_time_in_min = $event > 0 && $event <= 60 ? Math.abs($event) : null"
                    [name]="dp.DeliveryPartner.full_name" [title]="'Enter a number between 1-60 minutes'" appOnlyNumber>
                </div>
              </div>
            </div>
            }
          </div>
          <div class="adl-static-setup">
            <div class="ad-partner-wrapper" [class.d-none]="dp_push_mechanisum != 'Parallel'">
              <div class="d-flex flex-column justify-content-center align-items-start gap-1">
                <small class="mr-2">Push Wait Time</small>
                <div class="position-relative">
                  <input type="number" inputmode="decimal" class="w-50px ad-form-control" min="1" max="3"
                    [ngModel]="dp.push_waiting_time" (keyup)="editFunction($event,i,'push_waiting_time')"
                    [name]="dp?.DeliveryPartner?.full_name" style="border-radius: 5px;"
                    [title]="'Enter a number between 1-120'" [disabled]="dp_push_mechanisum != 'Parallel'"
                    appOnlyNumber>
                </div>
              </div>
            </div>
            <div class="ad-field-pair">
              <div class="ad-partner-wrapper">
                <div class="d-flex flex-column justify-content-center align-items-start gap-1">
                  <small class="mr-2">Min KM</small>
                  <div class="position-relative">
                    <input type="number" inputmode="decimal" class="w-50px ad-form-control" min="1" max="5"
                      [ngModel]="dp.min_km" (keyup)="editFunction($event,i,'min_km')"
                      [name]="dp?.DeliveryPartner?.full_name" style="  border-radius: 5px;"
                      [title]="'Enter a number between 0-5 km'" appOnlyNumber>
                  </div>
                </div>
              </div>
              <div class="ad-partner-wrapper">
                <div class="d-flex flex-column justify-content-center align-items-start gap-1">
                  <small class="mr-2">Max KM</small>
                  <div class="position-relative">
                    <input type="number" inputmode="decimal" class="w-50px ad-form-control" min="1" max="5"
                      [ngModel]="dp.max_km" (keyup)="editFunction($event,i,'max_km')"
                      [name]="dp?.DeliveryPartner?.full_name" style=" border-radius: 5px;"
                      [title]="'Enter a number between 1-50 km'" appOnlyNumber>
                  </div>
                </div>
              </div>
            </div>
            <div class="ad-field-pair">
              <div class="ad-partner-wrapper">
                <div class="d-flex flex-column justify-content-center align-items-start gap-1">
                  <small class="mr-2">Start Time</small>
                  <div class="position-relative">
                    <app-date-time-picker mode="time" size="sm" [ariaLabel]="'Start time'"
                      [ngModel]="utcToIst(dp.start_time)"
                      (ngModelChange)="dp.start_time = $event ? istToUtc($event) : null; validateKmRange(i)"
                      [name]="'start_time_' + i" />
                  </div>
                </div>
              </div>
              <div class="ad-partner-wrapper">
                <div class="d-flex flex-column justify-content-center align-items-start gap-1">
                  <small class="mr-2">End Time</small>
                  <div class="position-relative">
                    <app-date-time-picker mode="time" size="sm" [ariaLabel]="'End time'"
                      [ngModel]="utcToIst(dp.end_time)"
                      (ngModelChange)="dp.end_time = $event ? istToUtc($event) : null; validateKmRange(i)"
                      [name]="'end_time_' + i" />
                  </div>
                </div>
              </div>
            </div>
            <div class="ad-partner-wrapper">
              <div class="d-flex flex-column justify-content-center align-items-start gap-1">
                <small class="mr-2">Order Value</small>
                <div class="position-relative">
                  <input type="number" inputmode="decimal" class="w-50px ad-form-control" min="1" max="5"
                    [ngModel]="dp.max_order_value" (keyup)="editFunction($event,i,'max_order_value')"
                    [name]="dp?.DeliveryPartner?.full_name" style="border-radius: 5px;"
                    [title]="'Enter a number between 1-10000'" appOnlyNumber>
                </div>
              </div>
            </div>
            <div class="ad-partner-wrapper" [class.invisible]="dp.delivery_partner_user_id == 1">
              <div class="d-flex flex-column justify-content-center align-items-start gap-1">
                <small class="mr-2">Extra Charge</small>
                <div class="position-relative">
                  <input type="number" inputmode="decimal" class="w-50px ad-form-control" min="1" max="3"
                    [ngModel]="dp.allowed_extra_charge" (keyup)="editFunction($event,i,'allowed_extra_charge')"
                    [name]="dp?.DeliveryPartner?.full_name" style="border-radius: 5px;"
                    [title]="'Enter a number between 1-100'" [disabled]="dp.delivery_partner_user_id == 1"
                    appOnlyNumber>
                </div>
              </div>
            </div>
          </div>
          <div class="adl-control-action">
            <div class="ad-field-pair">
              <div class="ad-status-container cursor-pointer" [class.invisible]="!dp?.DeliveryPartner?.allow_cod_order">
                <div class="media ad-custom--switch flex-column-reverse">
                  <div class="media-body icon-state">
                    <label class="switch">
                      <input type="checkbox" [id]="'checkbox1' + i" (change)="allowCod($event,i)"
                        [checked]="dp.allow_cod" [disabled]="!dp?.DeliveryPartner?.allow_cod_order" /><span
                        class="switch-state"></span>
                    </label>
                  </div>
                  <label for="test" class="col-form-label p-0">COD</label>
                </div>
              </div>
              <div class="ad-status-container cursor-pointer">
                <div class="media ad-custom--switch flex-column-reverse">
                  <div class="media-body icon-state">
                    <label class="switch">
                      <input type="checkbox" [id]="'checkbox' + i" (change)="activeAndInactive($event,i)"
                        [checked]="dp.status==='Active'" /><span class="switch-state"></span>
                    </label>
                  </div>
                  <label for="test" class="col-form-label p-0">{{ dp.status === 'Active' ? 'Active' : 'InActive'
                    }}</label>
                </div>
              </div>
            </div>
            <div class="ad-status-container">
              <div class="ad-delete-icon cursor-pointer" (click)="deleteDeliveryPartner(dp,i)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="#8B8484">
                  <path
                    d="M7 4V2H17V4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z">
                  </path>
                </svg>
              </div>
            </div>
            <div class="ad-drag">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#8B8484">
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M16 13l6.964 4.062-2.973.85 2.125 3.681-1.732 1-2.125-3.68-2.223 2.15L16 13zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6zM4 14v2H2v-2h2zm0-4v2H2v-2h2zm0-4v2H2V6h2zm0-4v2H2V2h2zm4 0v2H6V2h2zm4 0v2h-2V2h2zm4 0v2h-2V2h2z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <!-- KM Validation Error Message -->
      @if (kmValidationErrors[i]) {
      <div class="km-validation-error">
        <p class="mb-0 ad-errors">{{kmValidationErrors[i]}}</p>
      </div>
      }
      }

      @if (!UserDeliveryPartnerMap.length) {
      <app-empty-state illustration="rider" size="compact" title="There is no delivery partners">
        <a class="btn ad-btn-small active" (click)="deliveryPartnerAdd()">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" stroke="currentColor" stroke-width="1.5">
              <path
                d="M2.364 12.958c-.38-2.637-.57-3.956-.029-5.083s1.691-1.813 3.992-3.183l1.385-.825C9.8 2.622 10.846 2 12 2s2.199.622 4.288 1.867l1.385.825c2.3 1.37 3.451 2.056 3.992 3.183s.35 2.446-.03 5.083l-.278 1.937c-.487 3.388-.731 5.081-1.906 6.093S16.553 22 13.106 22h-2.212c-3.447 0-5.17 0-6.345-1.012s-1.419-2.705-1.906-6.093z" />
              <path stroke-linecap="round" d="M15 13h-3m0 0H9m3 0v-3m0 3v3" />
            </g>
          </svg>
          <span>Add Delivery Partners</span>
        </a>
      </app-empty-state>
      }
    </div>

    <!-- ONDC Config Component -->
    <app-ondc-config #ondcConfig [clusterData]="userData" [userId]="userData?.userId"
      (ondcSaved)="onOndcSaved($event)"></app-ondc-config>

    <!-- Blurred Overlay for non-Own dp_setup -->
    @if (dp_setup !== 'Own' || (userData.role_id != constant.RoleId.vendor && apply_dp_setup == 'Own') ||
    (userData.role_id != constant.RoleId.vendor && apply_dp_setup == 'Cluster')) {
    <div class="blurred-overlay">
      <div class="blurred-content">
        <div class="blurred-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="1.5">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
            <path d="M12 6v6l4 2" />
            <path d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
          </svg>
        </div>
        @if(userData.role_id == constant.RoleId.masterAgency && userAgencyType == 'SAAS'){
        <p class="blurred-message">
          Select “{{ commonLogics.getCustomLabel('Master Agency') }}” in Change All Customer 3pl Setup to add or
          manage
          your mapped 3PL.
        </p>
        }
        @if(userData.role_id == constant.RoleId.masterAgency && userAgencyType == 'Customer'){
        <p class="blurred-message">
          Select “{{ commonLogics.getCustomLabel('Customer Master') }} in Change All Customer 3pl Setup to add or
          manage
          your mapped 3PL.
        </p>
        }
        @if(userData.role_id == constant.RoleId.agency && userAgencyType == 'SAAS'){
        <p class="blurred-message">
          Select “{{ commonLogics.getCustomLabel('Agency') }}” in Change All Customer 3pl Setup to add or manage your
          mapped 3PL.
        </p>
        }
        @if(userData.role_id == constant.RoleId.agency && userAgencyType == 'Customer'){
        <p class="blurred-message">
          Select “{{ commonLogics.getCustomLabel('Customer Group') }}” in Change All Customer 3pl Setup to add or
          manage
          your mapped 3PL.
        </p>
        }
        @if(userData.role_id == constant.RoleId.vendor){
        <p class="blurred-message">
          Select “Own” in Change All Customer 3pl Setup to add or manage your mapped 3PL.
        </p>
        }
      </div>
    </div>
    }
  </div>

  <div class="card-footer action-buttons-container justify-content-end mt-3">
    <button type="button" class="btn ad-btn-small active" (click)="deliveryPartnerAdd()"
      [disabled]="dp_setup !== 'Own'">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none" stroke="currentColor" stroke-width="1.5">
          <path
            d="M2.364 12.958c-.38-2.637-.57-3.956-.029-5.083s1.691-1.813 3.992-3.183l1.385-.825C9.8 2.622 10.846 2 12 2s2.199.622 4.288 1.867l1.385.825c2.3 1.37 3.451 2.056 3.992 3.183s.35 2.446-.03 5.083l-.278 1.937c-.487 3.388-.731 5.081-1.906 6.093S16.553 22 13.106 22h-2.212c-3.447 0-5.17 0-6.345-1.012s-1.419-2.705-1.906-6.093z" />
          <path stroke-linecap="round" d="M15 13h-3m0 0H9m3 0v-3m0 3v3" />
        </g>
      </svg>
      <span>Add</span>
    </button>
    @if (UserDeliveryPartnerMap.length) {
    <button type="button" class="btn ad-btn-small active" (click)="updateData()" [disabled]="dp_setup !== 'Own'">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g fill="none">
          <g clip-path="url(#solarSmartphoneUpdateOutline0)">
            <path fill="currentColor" fill-rule="evenodd"
              d="M2.035 3.25c.33-2.221 2.1-4 4.346-4C7.726-.75 8.914-.1 9.71.892a.75.75 0 1 1-1.17.938C7.998 1.154 7.224.75 6.38.75c-1.326 0-2.52 1.03-2.826 2.506a.75.75 0 0 1 .459 1.25l-.73.8a.75.75 0 0 1-1.108 0l-.73-.8a.75.75 0 0 1 .59-1.255M12.25 2a.75.75 0 0 1 .752-.748c1.547.004 2.8.03 3.807.2c1.028.175 1.872.512 2.55 1.19c.748.749 1.08 1.698 1.238 2.87c.153 1.14.153 2.595.153 4.433v4.112c0 1.838 0 3.294-.153 4.433c-.158 1.172-.49 2.121-1.238 2.87c-.749.748-1.698 1.08-2.87 1.238c-1.14.153-2.595.153-4.433.153h-.112c-1.838 0-3.294 0-4.433-.153c-1.172-.158-2.121-.49-2.87-1.238c-.748-.749-1.08-1.698-1.238-2.87c-.153-1.14-.153-2.595-.153-4.433v-3.055a.75.75 0 0 1 1.5 0V14c0 1.907.002 3.262.14 4.29c.135 1.005.389 1.585.812 2.008s1.003.677 2.009.812c1.028.138 2.382.14 4.289.14s3.262-.002 4.29-.14c1.005-.135 1.585-.389 2.008-.812s.677-1.003.812-2.009c.138-1.027.14-2.382.14-4.289v-4c0-1.907-.002-3.261-.14-4.29c-.135-1.005-.389-1.585-.812-2.008c-.385-.385-.898-.629-1.74-.772c-.864-.146-1.993-.174-3.56-.18A.75.75 0 0 1 12.25 2m-1.98.451a.75.75 0 0 1 .554.244l.73.8a.75.75 0 0 1-.59 1.255c-.328 2.221-2.098 4-4.344 4c-1.25 0-2.368-.562-3.158-1.44a.75.75 0 1 1 1.115-1.004c.534.594 1.258.944 2.043.944c1.326 0 2.52-1.03 2.826-2.506a.75.75 0 0 1-.459-1.25l.73-.8a.75.75 0 0 1 .554-.244M8.25 19a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75"
              clip-rule="evenodd" />
          </g>
          <defs>
            <clipPath id="solarSmartphoneUpdateOutline0">
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </g>
      </svg>
      <span>Update</span>
    </button>
    }
  </div>
  }
  @if (!deliveryPartnerShow) {
  <form [formGroup]="dpFormGroup" (ngSubmit)="addDeliveryPartner()" class="ad-flex-parent">
    <div class="ad-delivery-partner-container">
      <div class="ad-delivery-partner-container-inner">
        <div class="row mb-3">
          <div class="col-xl-4 col-md-6 col-sm-12">
            <div class="ad-form-group mb-0">
              <label class="ad-control-label">Delivery partner</label>
              <ng-select class="ad-select" bindLabel="full_name" bindValue="user_id" placeholder="Select"
                (change)="thirdPartyname($event)" formControlName="delivery_partner_user_id" [searchable]="true"
                [items]="deliveryPartnerList">
              </ng-select>
              @if (dpFormGroup.get('delivery_partner_user_id')?.invalid && submitted) {
              <p class="mb-0 ad-errors">Please choose delivery partner</p>
              }
            </div>
          </div>
          @if(dp_push_mechanisum != 'Parallel'){
          <div class="col-xl-4 col-md-6 col-sm-12">
            <div class="ad-form-group mb-0">
              <label class="ad-control-label">Order waiting time(mins)</label>
              <input class="ad-form-control" id="order-time" type="number" placeholder="Enter order time"
                formControlName="waiting_time_in_min" appOnlyNumber>
              @if (dpFormGroup.get('waiting_time_in_min')?.errors?.['required'] && submitted) {
              <p class="mb-0 ad-errors">Order waiting time is required</p>
              }
              @if(dpFormGroup.get('waiting_time_in_min')?.errors?.['negativeValue']) {
              <p class="mb-0 ad-errors">Order waiting time cannot be negative</p>
              }
              @if(dpFormGroup.get('waiting_time_in_min')?.errors?.['outOfRange']) {
              <p class="mb-0 ad-errors">Order waiting time must be between 1 - 60 minutes</p>
              }
              @if(dpFormGroup.get('waiting_time_in_min')?.errors?.['invalidNumber']) {
              <p class="mb-0 ad-errors">Please enter a valid number</p>
              }
            </div>
          </div>
          }
        </div>
      </div>
    </div>

    <div class="card-footer action-buttons-container justify-content-end mt-3">
      <button type="button" class="btn ad-btn-small active" (click)="backBtn()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="m4 12l6-6m-6 6l6 6m-6-6h10.5m5.5 0h-2.5" />
        </svg>
        <span>Back</span>
      </button>
      <button type="submit" class="btn ad-btn-small active">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M7.558 3.75H7.25a3.5 3.5 0 0 0-3.5 3.5v9.827a3.173 3.173 0 0 0 3.173 3.173v0m.635-16.5v2.442a2 2 0 0 0 2 2h2.346a2 2 0 0 0 2-2V3.75m-6.346 0h6.346m0 0h.026a3 3 0 0 1 2.122.879l3.173 3.173a3.5 3.5 0 0 1 1.025 2.475v6.8a3.173 3.173 0 0 1-3.173 3.173v0m-10.154 0V15a3 3 0 0 1 3-3h4.154a3 3 0 0 1 3 3v5.25m-10.154 0h10.154" />
        </svg>
        <span>Save</span>
      </button>
    </div>
  </form>
  }
</div>